/* =====================================================================================================================
   MJP GIFT CARD - "Leggi la tua carta" (sections/mjp-giftcard-reader.liquid, pagina /pages/gift-card)

   Patto con l'ERP: GIFTCARD_LETTORE_TEMA.md (v2, 06/10/2026).
   * Sulla carta c'e' un Code128 con il codice nudo: 8 caratteri esadecimali maiuscoli (es. 6DF19697).
   * Lettura: BarcodeDetector dove esiste e supporta code_128 (Chrome Android); altrimenti ZXing, caricato SOLO in quel
     caso e solo come asset del tema (assets/mjp-zxing.min.js), mai da un CDN.
   * UNA chiamata a verify, solo a lettura avvenuta (due letture uguali di fila); poi la fotocamera si spegne.
     Limite ERP: 10 richieste/minuto per IP -> sul 429 "Troppi tentativi, riprova fra un minuto".
   * Al cliente solo le frasi "reason" dell'ERP: niente messaggi tecnici.
   * Il codice NON si salva da nessuna parte (niente localStorage, cookie o URL): e' denaro.
   ===================================================================================================================== */
(function () {
  'use strict';
  if (window.__mgcReader) return;
  window.__mgcReader = true;

  var CODE_RE = /^[0-9A-F]{8}$/;

  function qs(el, s) { return el.querySelector(s); }
  function qsa(el, s) { return Array.prototype.slice.call(el.querySelectorAll(s)); }

  /* Testo letto -> codice nudo, oppure null se non ha la forma di un codice MJP */
  function normalize(raw) {
    var c = String(raw || '').toUpperCase().replace(/[\s-]/g, '');
    return CODE_RE.test(c) ? c : null;
  }

  /* ZXing: decodifica un Code128 da un buffer di grigi (larghezza w, altezza h). Ritorna il testo o null. */
  function zxDecode(ZX, reader, hints, lum, w, h) {
    try {
      var src = new ZX.RGBLuminanceSource(lum, w, h);
      var bmp = new ZX.BinaryBitmap(new ZX.HybridBinarizer(src));
      return reader.decode(bmp, hints).getText();
    } catch (e) {
      try { reader.reset(); } catch (e2) {}
      return null;
    }
  }

  var zxPromise = null;
  function loadZXing(url) {
    if (window.ZXing) return Promise.resolve(window.ZXing);
    if (zxPromise) return zxPromise;
    zxPromise = new Promise(function (resolve, reject) {
      var s = document.createElement('script');
      s.src = url; s.async = true;
      s.onload = function () { window.ZXing ? resolve(window.ZXing) : reject(new Error('zxing')); };
      s.onerror = function () { zxPromise = null; reject(new Error('zxing')); };
      document.head.appendChild(s);
    });
    return zxPromise;
  }

  function init(root) {
    if (root.dataset.mgcBound) return;
    root.dataset.mgcBound = '1';

    var D = root.dataset;
    var T = {
      tooMany: D.tTooMany, offline: D.tOffline, noCamera: D.tNoCamera, denied: D.tDenied,
      copied: D.tCopied, copy: D.tCopy, notFound: D.tNotFound,
      apply: D.tApply, applyDesk: D.tApplyDesk, applied: D.tApplied, appliedDesk: D.tAppliedDesk, applyError: D.tApplyError
    };
    var el = {
      idle: qs(root, '[data-rd-idle]'), scan: qs(root, '[data-rd-scan]'), busy: qs(root, '[data-rd-busy]'),
      ok: qs(root, '[data-rd-ok]'), bad: qs(root, '[data-rd-bad]'), video: qs(root, '[data-rd-video]'),
      start: qs(root, '[data-rd-start]'), stop: qs(root, '[data-rd-stop]'), torch: qs(root, '[data-rd-torch]'),
      msg: qs(root, '[data-rd-msg]'), badText: qs(root, '[data-rd-bad-text]'),
      okActions: qs(root, '[data-rd-ok-actions]'), badActions: qs(root, '[data-rd-bad-actions]'),
      copy: qs(root, '[data-rd-copy]'), copyLabel: qs(root, '[data-rd-copy-label]'),
      code: qs(root, '[data-rd-code]'), balance: qs(root, '[data-rd-balance]'), exp: qs(root, '[data-rd-exp]'), expWrap: qs(root, '[data-rd-exp-wrap]'),
      desk: qs(root, '[data-rd-desk]'),
      apply: qs(root, '[data-rd-apply]'), applyLabel: qs(root, '[data-rd-apply-label]'), applied: qs(root, '[data-rd-applied]'),
      appliedText: qs(root, '[data-rd-applied-text]'), checkout: qs(root, '[data-rd-checkout]'), linked: qs(root, '[data-rd-linked]'),
      flip: qs(root, '[data-rd-flip]'), done: qs(root, '[data-rd-done]'), doneAmount: qs(root, '[data-rd-done-amount]')
    };
    var facing = 'environment'; /* fotocamera posteriore; il pulsante "cambia" passa alla frontale */

    /* Applica al carrello (assets/mjp-gc-cart.js, attivo da Impostazioni tema > Gift card e carrello).
       #c=<token> = carrello del computer, arrivato dal QR: si tiene solo in memoria e si toglie subito dall'indirizzo.
       #apply = arrivo dal carrello di questo telefono: la fotocamera parte da sola. */
    /* mjp-gc-cart.js si carica dopo questo script: si cerca al momento dell'uso */
    function gcApi() { var G = window.MJPGiftCart; return G && G.config.reader_apply ? G : null; }
    var gcFlag = document.getElementById('mjp-gc-cfg'), gcOn = false, gcCfg = null;
    try { gcCfg = gcFlag ? JSON.parse(gcFlag.textContent) : null; gcOn = !!(gcCfg && gcCfg.reader_apply); } catch (e) {}
    var gcT = (gcCfg && gcCfg.t) || {};
    var cartMode = D.mode === 'cart'; /* dentro il carrello: la carta letta si applica subito a questo carrello */
    var linkedGid = null, viewGid = null, autoStart = false;
    (function () {
      var h = location.hash || '';
      var m = /[#&]c=([^&]+)/.exec(h);
      var v = /[#&]v=([^&]+)/.exec(h); /* QR di consultazione dal computer */
      if (v && gcCfg && !cartMode) viewGid = 'gid://shopify/Cart/' + decodeURIComponent(v[1]);
      if (m || v || h === '#apply') {
        try { history.replaceState(null, '', location.pathname + location.search); } catch (e) {}
        autoStart = true;
      }
      if (m && gcOn) linkedGid = 'gid://shopify/Cart/' + decodeURIComponent(m[1]);
    })();
    if (linkedGid && el.linked) el.linked.hidden = false;
    if (viewGid && el.linked) { el.linked.lastChild.textContent = ' ' + (gcT.qrv_linked || ''); el.linked.hidden = false; }

    /* Dal computer: "Leggila col telefono" (QR). Senza webcam e' l'unica scelta; con la webcam e' un'alternativa. */
    var isDesk = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    var qrBtn = qs(root, '[data-rd-qr]'), qrOn = !!(qrBtn && gcCfg && !cartMode && !linkedGid && !viewGid && isDesk), noCam = false;
    if (qrOn) {
      qs(qrBtn, '[data-rd-qr-label]').textContent = gcT.qrv_btn || '';
      qrBtn.hidden = false;
      if (el.desk) el.desk.remove(); /* sostituisce l'invito "apri questa pagina dal telefono" */
      if (navigator.mediaDevices && navigator.mediaDevices.enumerateDevices) {
        navigator.mediaDevices.enumerateDevices().then(function (ds) {
          noCam = !ds.some(function (d) { return d.kind === 'videoinput'; });
          if (noCam) { qrBtn.classList.remove('mgc-btn--ghost'); if (el.start) el.start.hidden = true; }
        }).catch(function () {});
      } else { noCam = true; if (el.start) el.start.hidden = true; qrBtn.classList.remove('mgc-btn--ghost'); }
      qrBtn.addEventListener('click', function () {
        var go = function () { window.MJPGiftCart.openQR({ mode: 'view', onResult: showRemote }); };
        if (window.MJPGiftCart) go(); else setTimeout(function () { if (window.MJPGiftCart) go(); }, 400);
      });
    }

    var stream = null, track = null, timer = null, running = false, last = null, hits = 0, frame = 0;
    var current = null; /* il codice letto vive solo qui, in memoria, finche' la pagina e' aperta */
    var canvas = document.createElement('canvas'), ctx = canvas.getContext('2d', { willReadFrequently: true });
    var detect = null, need = 2; /* letture uguali di fila prima di chiamare verify: 2 col lettore del telefono, 3 con ZXing */

    function view(name) {
      ['idle', 'scan', 'busy', 'ok', 'bad'].forEach(function (k) { if (el[k]) el[k].hidden = (k !== name); });
      if (el.okActions) el.okActions.hidden = name !== 'ok';
      if (el.badActions) el.badActions.hidden = name !== 'bad';
      if (el.start) el.start.hidden = !(name === 'idle') || noCam;
      if (qrBtn && qrOn) qrBtn.hidden = !(name === 'idle');
      if (typeof oldOn !== 'undefined' && oldOn) old.box.hidden = name !== 'idle' && name !== 'scan';
    }
    function say(text) { if (!el.msg) return; el.msg.textContent = text || ''; el.msg.hidden = !text; }

    /* Dal computer: invito ad aprire la pagina dal telefono (si puo' comunque provare con la webcam) */
    if (el.desk && !linkedGid && window.matchMedia('(hover: hover) and (pointer: fine)').matches) el.desk.hidden = false;

    function stopCamera() {
      running = false;
      clearTimeout(timer); timer = null;
      if (stream) stream.getTracks().forEach(function (t) { t.stop(); });
      stream = null; track = null;
      if (el.video) el.video.srcObject = null;
      if (el.torch) { el.torch.hidden = true; el.torch.setAttribute('aria-pressed', 'false'); }
    }

    function pickDecoder() {
      if ('BarcodeDetector' in window && typeof window.BarcodeDetector.getSupportedFormats === 'function') {
        return window.BarcodeDetector.getSupportedFormats().then(function (f) {
          if (f.indexOf('code_128') < 0) throw new Error('no-128');
          var bd = new window.BarcodeDetector({ formats: ['code_128'] });
          need = 2;
          return function () {
            return bd.detect(el.video).then(function (r) { return r.length ? r[0].rawValue : null; });
          };
        }).catch(function () { return zxDecoder(); });
      }
      return zxDecoder();
    }

    function zxDecoder() {
      return loadZXing(D.zxing).then(function (ZX) {
        var reader = new ZX.Code128Reader();
        var hints = new Map();
        hints.set(ZX.DecodeHintType.TRY_HARDER, true);
        need = 3;
        return function () {
          var v = el.video, vw = v.videoWidth, vh = v.videoHeight;
          if (!vw || !vh) return Promise.resolve(null);
          /* Fascia centrale (dove sta la guida). La larghezza alterna 1280 e 900px tra un fotogramma e l'altro: un errore
             di lettura dovuto al ridimensionamento non si ripete uguale a due scale diverse (con le 3 letture di fila). */
          var sx = vw * 0.06, sy = vh * 0.22, sw = vw * 0.88, sh = vh * 0.56;
          var dw = Math.min(frame % 2 ? 900 : 1280, Math.round(sw)), dh = Math.round(sh * dw / sw);
          canvas.width = dw; canvas.height = dh;
          ctx.drawImage(v, sx, sy, sw, sh, 0, 0, dw, dh);
          var px = ctx.getImageData(0, 0, dw, dh).data, n = dw * dh, lum = new Uint8ClampedArray(n);
          for (var i = 0, j = 0; i < n; i++, j += 4) lum[i] = (px[j] * 77 + px[j + 1] * 150 + px[j + 2] * 29) >> 8;
          var out = zxDecode(ZX, reader, hints, lum, dw, dh);
          /* Un fotogramma su tre prova anche la carta in verticale (immagine trasposta) */
          if (!out && (frame % 3 === 2)) {
            var t = new Uint8ClampedArray(n);
            for (var y = 0; y < dh; y++) for (var x = 0; x < dw; x++) t[x * dh + y] = lum[y * dw + x];
            out = zxDecode(ZX, reader, hints, t, dh, dw);
          }
          return Promise.resolve(out);
        };
      });
    }

    function loop() {
      if (!running) return;
      frame++;
      detect().then(function (raw) {
        if (!running) return;
        var code = normalize(raw);
        if (raw && !code) { hits = 0; last = null; }
        if (code) {
          hits = (code === last) ? hits + 1 : 1;
          last = code;
          if (hits >= need) { stopCamera(); verify(code); return; }
        }
        timer = setTimeout(loop, 110);
      }).catch(function () { if (running) timer = setTimeout(loop, 250); });
    }

    function start() {
      say('');
      if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) { say(T.noCamera); return; }
      el.start.disabled = true;
      navigator.mediaDevices.getUserMedia({
        audio: false,
        video: { facingMode: { ideal: facing }, width: { ideal: 1920 }, height: { ideal: 1080 } }
      }).then(function (s) {
        stream = s; track = s.getVideoTracks()[0];
        el.video.srcObject = s;
        el.video.setAttribute('playsinline', '');
        el.video.muted = true;
        return el.video.play();
      }).then(function () {
        /* Messa a fuoco continua e torcia, dove il telefono le offre */
        el.video.classList.toggle('is-front', facing === 'user');
        /* Pulsante "cambia fotocamera" solo se il dispositivo ne ha piu' di una */
        if (el.flip && navigator.mediaDevices.enumerateDevices) {
          navigator.mediaDevices.enumerateDevices().then(function (ds) {
            el.flip.hidden = ds.filter(function (d) { return d.kind === 'videoinput'; }).length < 2;
          }).catch(function () {});
        }
        try {
          var caps = track.getCapabilities ? track.getCapabilities() : {};
          if (caps.focusMode && caps.focusMode.indexOf('continuous') > -1) track.applyConstraints({ advanced: [{ focusMode: 'continuous' }] }).catch(function () {});
          if (caps.torch && el.torch) el.torch.hidden = false;
        } catch (e) {}
        return pickDecoder();
      }).then(function (fn) {
        detect = fn; last = null; hits = 0; frame = 0; running = true;
        view('scan');
        loop();
      }).catch(function (err) {
        stopCamera();
        view('idle');
        say(err && (err.name === 'NotAllowedError' || err.name === 'SecurityError') ? T.denied : T.noCamera);
      }).then(function () { el.start.disabled = false; });
    }

    function verify(code) {
      view('busy');
      var url = D.endpoint + (D.endpoint.indexOf('?') > -1 ? '&' : '?') + 'code=' + encodeURIComponent(code);
      fetch(url, { method: 'GET', mode: 'cors', credentials: 'omit', cache: 'no-store', headers: { 'Accept': 'application/json' } })
        .then(function (r) {
          if (r.status === 429) return { valid: false, reason: T.tooMany };
          return r.json().catch(function () { return null; }).then(function (d) {
            if (d && typeof d === 'object' && 'valid' in d) return d;
            if (r.status === 404) return { valid: false, reason: T.notFound };
            throw new Error('bad');
          });
        })
        .then(function (d) { d.valid ? showOk(d) : showBad(d.reason || T.notFound); relay(d); })
        .catch(function () { showBad(T.offline); });
    }

    /* Consultazione dal computer: al computer arrivano solo saldo, scadenza e ultime 4 cifre (mai il codice) */
    function relay(d) {
      if (!viewGid || !window.MJPGiftCart || !window.MJPGiftCart.sendView) return;
      var data = d.valid
        ? { ok: true, last4: String(d.code || '').slice(-4).toUpperCase(), balance_cents: d.balance_cents, currency: d.currency, expires_at: d.expires_at || null }
        : { ok: false, reason: d.reason || T.notFound };
      window.MJPGiftCart.sendView(viewGid, data).then(function () {
        if (el.linked) { el.linked.lastChild.textContent = ' ' + (gcT.qrv_sent || ''); el.linked.classList.add('is-sent'); }
      }).catch(function () {});
    }

    /* Computer: risultato arrivato dal telefono */
    function showRemote(d) {
      if (!d || !d.ok) { showBad((d && d.reason) || T.notFound); return; }
      current = null;
      el.code.textContent = '•••• ' + (d.last4 || '');
      el.balance.textContent = money(d.balance_cents, d.currency);
      var e = date(d.expires_at);
      el.exp.textContent = e;
      el.expWrap.hidden = !e;
      resetApply();
      view('ok');
      if (el.copy) el.copy.hidden = true; /* il codice completo resta sul telefono */
      var how = qs(root, '.mgc-rd__how'); if (how) how.hidden = true;
      say(gcT.qrv_code || '');
      if (el.msg) el.msg.classList.add('is-info');
    }

    function money(cents, cur) {
      /* stesso formato del negozio (es. €50,00) quando il modulo carrello e' attivo */
      if (window.MJPGiftCart && window.MJPGiftCart.formatCents && (!cur || cur === 'EUR')) return window.MJPGiftCart.formatCents(cents || 0);
      try { return new Intl.NumberFormat('it-IT', { style: 'currency', currency: cur || 'EUR' }).format((cents || 0) / 100); }
      catch (e) { return ((cents || 0) / 100).toFixed(2).replace('.', ',') + ' €'; }
    }
    function date(iso) {
      var m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso || '');
      if (!m) return '';
      return new Date(+m[1], +m[2] - 1, +m[3]).toLocaleDateString('it-IT', { day: 'numeric', month: 'long', year: 'numeric' });
    }

    function showOk(d) {
      current = String(d.code || '').toUpperCase();
      balance = +d.balance_cents || 0;
      if (el.copy && !cartMode) el.copy.hidden = false;
      var how = qs(root, '.mgc-rd__how'); if (how) how.hidden = false;
      if (el.msg) el.msg.classList.remove('is-info');
      el.code.textContent = d.code_formatted || (current.slice(0, 4) + '-' + current.slice(4));
      el.balance.textContent = money(d.balance_cents, d.currency);
      var e = date(d.expires_at);
      el.exp.textContent = e;
      el.expWrap.hidden = !e;
      if (el.copyLabel) el.copyLabel.textContent = T.copy;
      resetApply();
      view('ok');
      offerApply();
      if (el.copy) el.copy.focus({ preventScroll: true });
    }
    /* Pulsante "Applica": col carrello del computer sempre; col carrello del telefono solo se non e' vuoto */
    var applyGid = null, balance = 0, amount = 0, maxAmount = 0;
    var amt = {
      box: qs(root, '[data-rd-amt]'), title: qs(root, '[data-rd-amt-title]'), val: qs(root, '[data-rd-amt-val]'), of: qs(root, '[data-rd-amt-of]'),
      range: qs(root, '[data-rd-amt-range]'), chips: qs(root, '[data-rd-amt-chips]'), note: qs(root, '[data-rd-amt-note]')
    };
    function resetApply() {
      applyGid = null; amount = 0; maxAmount = 0;
      if (el.apply) { el.apply.hidden = true; el.apply.disabled = false; }
      if (el.applied) el.applied.hidden = true;
      if (el.checkout) el.checkout.hidden = true;
      if (amt.box) amt.box.hidden = true;
    }

    /* Importo parziale (patto ERP v3, par. 6): il cliente sceglie quanto usare, da 1 € a min(saldo, totale carrello) */
    function setAmount(cents) {
      var GC = gcApi(), tt = GC.config.t || {};
      amount = Math.max(Math.min(cents, maxAmount), Math.min(100, maxAmount));
      amt.val.textContent = GC.formatCents(amount);
      amt.range.value = Math.min(amount, +amt.range.max);
      amt.range.style.setProperty('--p', (+amt.range.max > 100 ? ((amt.range.value - 100) / (amt.range.max - 100)) * 100 : 100) + '%');
      qsa(amt.chips, 'button').forEach(function (b) { b.setAttribute('aria-pressed', +b.getAttribute('data-cents') === amount ? 'true' : 'false'); });
      el.applyLabel.textContent = (tt.amt_use || '') + ' ' + GC.formatCents(amount);
    }
    function showChooser(totalCents) {
      var GC = gcApi(), tt = GC.config.t || {};
      maxAmount = Math.min(balance, totalCents > 0 ? totalCents : balance);
      if (!amt.box || maxAmount <= 100) { amount = maxAmount; return false; } /* niente da scegliere */
      amt.title.textContent = tt.amt_title || '';
      amt.of.textContent = '/ ' + GC.formatCents(balance);
      amt.note.textContent = tt.amt_rest || '';
      amt.range.min = 100;
      amt.range.max = Math.max(100, Math.floor(maxAmount / 100) * 100);
      amt.chips.innerHTML = '';
      [1000, 2000, 5000].filter(function (c) { return c < maxAmount; }).concat([maxAmount]).forEach(function (c, i, all) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'mgc-amt__chip'; b.setAttribute('data-cents', c);
        b.textContent = i === all.length - 1 ? (tt.amt_all || GC.formatCents(c)) : GC.formatCents(c);
        b.addEventListener('click', function () { setAmount(c); });
        amt.chips.appendChild(b);
      });
      amt.box.hidden = false;
      setAmount(maxAmount);
      return true;
    }
    if (amt.range) amt.range.addEventListener('input', function () {
      var v = +amt.range.value;
      setAmount(v >= +amt.range.max ? maxAmount : v);
    });

    function offerApply() {
      var GC = gcApi();
      if (!GC || !el.apply) return;
      var partial = !!GC.config.partial;
      if (linkedGid) {
        applyGid = linkedGid; el.applyLabel.textContent = T.applyDesk; el.apply.hidden = false;
        if (!partial) { applyCard(); return; }
        GC.status(linkedGid).then(function (cart) {
          var tot = cart && cart.cost ? Math.round(+cart.cost.totalAmount.amount * 100) : 0;
          if (!showChooser(tot)) applyCard();
        }).catch(function () { applyCard(); });
        return;
      }
      if (!cartMode) return; /* pagina "Leggi la tua carta" senza QR: niente pulsante, solo il codice da copiare */
      GC.myCart().then(function (c) {
        if (!current || !c.count) return;
        applyGid = c.gid; el.applyLabel.textContent = T.apply; el.apply.hidden = false;
        if (!partial || !showChooser(c.total)) applyCard();
      }).catch(function () {});
    }
    function applyCard() {
      var GC = gcApi();
      if (!GC || !applyGid || !current) return;
      el.apply.disabled = true; say('');
      GC.applyAmount(applyGid, current, amount, balance).then(function (r) {
        if (!r.ok) { var e = new Error('apply'); e.reason = r.reason; throw e; }
        applied(r);
      }).catch(function (e) {
        el.apply.disabled = false;
        say((e && e.reason) || T.applyError); /* solo frasi dell'ERP o il testo dell'impostazione */
      });
    }

    /* Carta applicata (codice a barre o codice digitato del vecchio sistema) */
    function applied(r) {
      var GC = gcApi();
      el.apply.hidden = true;
      if (amt.box) amt.box.hidden = true;
      if (linkedGid && el.done) {
        if (el.doneAmount) el.doneAmount.textContent = '−' + GC.money(r.card.amountUsed);
        el.done.hidden = false;
        document.documentElement.style.overflow = 'hidden';
        var a = el.done.querySelector('a'); if (a) a.focus({ preventScroll: true });
      }
      el.appliedText.textContent = linkedGid ? T.appliedDesk : (T.applied + ' −' + GC.money(r.card.amountUsed));
      el.applied.hidden = false;
      if (el.checkout && !linkedGid) el.checkout.hidden = false;
      current = null; /* il codice non serve piu': dopo la riserva bastano reservation_id e carrello */
      document.dispatchEvent(new CustomEvent('mjp:gc-applied', { detail: { card: r.card, cart: r.cart, reservation: r.reservation } }));
    }

    /* ---------- Gift card del vecchio sistema: codice digitato (solo dove si applica a un carrello) ---------- */
    var old = {
      box: qs(root, '[data-rd-old]'), toggle: qs(root, '[data-rd-old-toggle]'), form: qs(root, '[data-rd-old-form]'),
      input: qs(root, '[data-rd-old-input]'), go: qs(root, '[data-rd-old-go]'), msg: qs(root, '[data-rd-old-msg]')
    };
    var oldOn = !!(old.box && gcCfg && gcCfg.old && gcCfg.reader_apply && (cartMode || linkedGid)), oldTries = 0;
    function oldSay(t) { old.msg.textContent = t || ''; old.msg.hidden = !t; }
    function oldOpen(open) {
      old.form.hidden = !open;
      old.toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) setTimeout(function () { old.input.focus(); }, 50);
    }
    if (oldOn) {
      qs(old.box, '[data-rd-old-link]').textContent = gcT.old_link || '';
      qs(old.box, '[data-rd-old-label]').textContent = gcT.old_label || '';
      qs(old.box, '[data-rd-old-note]').textContent = gcT.old_note || '';
      old.input.placeholder = gcT.old_placeholder || '';
      old.go.textContent = gcT.old_apply || '';
      old.box.hidden = false;
      old.toggle.addEventListener('click', function () { oldOpen(old.form.hidden); });
      old.input.addEventListener('input', function () { oldSay(''); });
      old.form.addEventListener('submit', function (e) {
        e.preventDefault();
        var raw = old.input.value.toUpperCase().replace(/\s+/g, '');
        if (!raw) { old.input.focus(); return; }
        /* codice delle carte nuove (8 caratteri esadecimali): si legge solo con la fotocamera (patto ERP, par. 5) */
        if (/^[0-9A-F]{8}$/.test(raw.replace(/-/g, ''))) { oldSay(gcT.old_new); return; }
        if (!/^[A-Z0-9-]{6,32}$/.test(raw)) { oldSay(gcT.old_error); return; }
        if (++oldTries > 5) { oldSay(gcT.too_many); return; }
        var GC = gcApi(); if (!GC) return;
        old.go.disabled = true; oldSay('');
        (linkedGid ? Promise.resolve({ gid: linkedGid }) : GC.myCart())
          .then(function (c) { applyGid = c.gid; return GC.applyRaw(c.gid, raw); })
          .then(function (r) {
            old.go.disabled = false;
            if (!r.ok) { oldSay(gcT.old_error); return; }
            old.input.value = ''; oldOpen(false);
            stopCamera(); view('ok');
            el.code.textContent = '•••• ' + r.card.lastCharacters.toUpperCase();
            el.balance.textContent = GC.money(r.card.balance);
            el.expWrap.hidden = true;
            if (el.copy) el.copy.hidden = true;
            applied(r);
          })
          .catch(function () { old.go.disabled = false; oldSay(gcT.old_error); });
      });
    }
    /* richiamabile dal carrello: apre direttamente il campo del codice */
    root.mgcOpenOld = function () { if (oldOn) { view('idle'); oldOpen(true); } };

    function showBad(reason) {
      current = null;
      el.badText.textContent = reason;
      view('bad');
    }

    function copy() {
      if (!current) return;
      var done = function () { if (el.copyLabel) { el.copyLabel.textContent = T.copied; setTimeout(function () { el.copyLabel.textContent = T.copy; }, 2200); } };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(current).then(done, fallback);
      } else fallback();
      function fallback() {
        var ta = document.createElement('textarea');
        ta.value = current; ta.setAttribute('readonly', ''); ta.style.position = 'fixed'; ta.style.opacity = '0';
        document.body.appendChild(ta); ta.select();
        try { document.execCommand('copy'); done(); } catch (e) {}
        document.body.removeChild(ta);
      }
    }

    function again() {
      current = null; say(''); resetApply(); view('idle');
      if (noCam) return; /* computer senza webcam: si torna alla scelta "Leggila col telefono" */
      start();
    }

    if (el.start) el.start.addEventListener('click', start);
    if (el.stop) el.stop.addEventListener('click', function () { stopCamera(); view('idle'); });
    if (el.copy) el.copy.addEventListener('click', copy);
    if (el.apply) el.apply.addEventListener('click', applyCard);
    qsa(root, '[data-rd-again]').forEach(function (b) { b.addEventListener('click', again); });
    if (el.flip) el.flip.addEventListener('click', function () {
      facing = facing === 'environment' ? 'user' : 'environment';
      stopCamera();
      start();
    });
    if (el.torch) el.torch.addEventListener('click', function () {
      if (!track) return;
      var on = el.torch.getAttribute('aria-pressed') !== 'true';
      track.applyConstraints({ advanced: [{ torch: on }] }).then(function () { el.torch.setAttribute('aria-pressed', on ? 'true' : 'false'); }).catch(function () {});
    });
    /* Fotocamera spenta quando si lascia la pagina o la scheda */
    document.addEventListener('visibilitychange', function () { if (document.hidden && running) { stopCamera(); view('idle'); } });
    window.addEventListener('pagehide', function () { stopCamera(); current = null; });

    view('idle');
    if (autoStart) start();
  }

  function boot() { qsa(document, '[data-mgc-reader]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target && e.target.querySelector && e.target.querySelector('[data-mgc-reader]');
    if (r) init(r);
  });
})();
